import type { ThemeConfig } from "antd";

/** Design tokens aligned with tema-trendy VTEX store */
export const TRENDY_COLORS = {
  primary: "#E24585",
  primaryLight: "rgba(226, 69, 133, 0.2)",
  primaryBg: "#fef8fb",
  primaryBgAlt: "#fff8fb",
  text: "#313131",
  textStrong: "#000000",
  border: "#eeeeee",
  borderInput: "#bcbdbc",
  bgMuted: "#f2f2f2",
  success: "#2d7a4f",
  successBg: "#e8f5ee",
  warning: "#b8860b",
  warningBg: "#fef6e6",
  error: "#c0392b",
  errorBg: "#fdeaea",
  info: "#E24585",
  infoBg: "#fff0f6",
} as const;

export const trendyTheme: ThemeConfig = {
  token: {
    colorPrimary: TRENDY_COLORS.primary,
    colorLink: TRENDY_COLORS.primary,
    colorText: TRENDY_COLORS.text,
    // Borde más definido para inputs/botones/cards (antes #eeeeee se veía lavado)
    colorBorder: "#d4d7dd",
    // Líneas internas (divisores de tabla) más suaves
    colorBorderSecondary: "#eef0f3",
    fontFamily: "'Barlow', sans-serif",
    borderRadius: 8,
    colorBgContainer: "#ffffff",
  },
  components: {
    Button: {
      primaryShadow: "none",
      defaultShadow: "none",
      controlHeight: 38,
      paddingInline: 18,
      fontWeight: 500,
      defaultBorderColor: "#d4d7dd",
      defaultColor: TRENDY_COLORS.text,
      defaultHoverBorderColor: TRENDY_COLORS.primary,
      defaultHoverColor: TRENDY_COLORS.primary,
    },
    Table: {
      headerBg: TRENDY_COLORS.primaryBg,
      headerColor: TRENDY_COLORS.text,
      rowHoverBg: TRENDY_COLORS.primaryBgAlt,
      borderColor: TRENDY_COLORS.border,
      // Densidad más premium / aireada
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
      headerSplitColor: "transparent",
      headerBorderRadius: 0,
    },
    Input: {
      activeBorderColor: TRENDY_COLORS.primary,
      hoverBorderColor: TRENDY_COLORS.primary,
      controlHeight: 38,
    },
    Modal: {
      borderRadiusLG: 16,
      titleFontSize: 18,
    },
    Tag: {
      defaultBg: TRENDY_COLORS.bgMuted,
    },
  },
};
